<div class="_wf-maincard-contain" [ngClass]="checkCondition(item)? 'border-card': 'no-border-card'">
  @if (header) {
    <!--for patient card top section-->
    <div class="_wf-card-level1" (click)="rowClickEmit()">
      <div class="_wf-level1__avatar">
        <!-- <span *ngFor="let profile of profileData;"> -->
        @for (profile of profileData; track profile) {
          @if (!imageURL && profile.image == true && profile.valid) {
            <img
              src="./assets/images/{{profile.image_name}}" width="85">
            }
            @if (imageURL && profile.image == true && profile.valid) {
              <img [src]="imageURL | secure  | async"
                width="85">
            }
          }
          @for (profile of profileData; track profile) {
            @if (!profile.image && profile.valid) {
              <p class="{{profile.class_name}}">{{getValue(item, field)}}
              </p>
            }
          }
        <!-- </span> -->
      </div>
      <div class="_wf-level1__bio">
        @for (field of headerResource; track field; let i = $index) {
          @if (field.valid) {
            @if (field.icon) {
              <img class="speciality-icon" src="assets/images/{{field.icon}}">
            }
            @if (field.heading && field.valid) {
              <label class="mr-2" for="apptId">
                {{field.heading | translate | async}}
              </label>
            }
            <div class="{{field.class_name}}">{{getValue(item, field)}}</div>
          }
        }
      </div>
    </div>
    <!--for ambulance card top section-->
    <!-- <div class="_wf-card-ambulance">
    <div class="_wf-card-ambulance__details">
      <div class="_wf-card-ambulance__details-regno">
        <h5 class="_heading-5">HR26 8055</h5>
      </div>
      <div class="_wf-card-ambulance__details-status"><img src="assets/images/icon-green-light.svg" loading="lazy" alt="">
        <h3 class="_heading-3">Enroute to the you</h3>
      </div>
    </div>
    <div class="_wf-card-ambulance__eta">
      <h3 class="_heading-3 no-space">ETA 3hrs 35 mins</h3>
    </div>
  </div> -->
}
<!--for card middle section-->
@if (!viewMap) {
  <div class="_wf-card-level2"  (click)="rowClickEmit()">
    <!-- <div > -->
    <!-- <div class="row"> -->
    @for (field of bodyResource; track field) {
      @if (field.valid) {
        <div class="card-details__contain 1">
          <h3 class="_heading-3" for="apptId">{{field.heading | translate | async}}</h3>
          @if (field.type !== 'date' && field.type !== 'datetime') {
            <h4 class="_heading-4"
              [ngClass]="(field.grid_color_text!=undefined && field.grid_color_text) ||(field.name == 'priority' || field.name== 'priority_name' || field.name == 'servicePriority')?getClass(item, field):''"
              [class.uhid-value-highlight]="field.name === 'uhId'">
            {{getValue(item, field)}}</h4>
          }
          @if (field.type == 'date') {
            <h4 class="_heading-4">{{item[field.name] | dateFormat}}</h4>
          }
          @if (field.type == 'datetime') {
            <h4 class="_heading-4">{{item[field.name] | dateTimeFormat}}</h4>
          }
          @if (field.type == 'time') {
            <h4 class="_heading-4">{{item[field.name] | timeFormat}}</h4>
          }
          @if (field.type === 'HashMap' && item['tag_data']!=undefined && item['tag_data'].length!=undefined) {
            <h4 class="_heading-4"
              >
              <!-- {{ getValue(item, field)}} -->
              @for (key of item['tag_data']; track key) {
                @if (key.visible) {
                  {{key.key_name}}&nbsp;:&nbsp;{{key.key_value_display | mask}}
                }
              }
            </h4>
          }
          @if (field.type === 'icon_pic') {
            <span class="_heading-4">
              @for (image of field.image_conditions; track image) {
                <ng-template #image_popover_data>
                  <span>{{image.popover_data | translate |async}}</span>
                </ng-template>
                @if (checkBannerExpression(image.expression,item)) {
                  <img [popover]="field.show_popover?image_popover_data:''" class="Imageconditionflag" placement="bottom" container="body" triggers="mouseenter:mouseleave" src="assets/images/{{image.path}}">
                }
              }
            </span>
          }
        </div>
      }
    }
  <!-- </div> -->
<!-- </div> -->
</div>
}
@if (viewMap && ambulanceData) {
  <div class="d-flex ambulance-card-body justify-content-center align-items-center">
    <!-- <ng-template> -->
    @if (!ambulanceData.polyline) {
      <span class="text-danger">* Paramedic not Logged In</span>
    }
    @if (ambulanceData.polyline) {
      <app-polyline [latitude]="ambulanceData.pickup_latitude"
        [longitude]="ambulanceData.pickup_longitude" [gmap-height]="'24vh'" [gmap-width]="''"
      [name]="ambulanceData.id" [polyLineData]="ambulanceData.polyline"></app-polyline>
    }
  <!-- </ng-template> -->
</div>
}
<!--for card toggle-->
<!-- <div class="_wf-card-expand"><img src="assets/images/icon-expand.svg" loading="lazy" alt=""></div> -->
<!--for card bottom section-->
<div class="_card-footer">
  @if (footerResource && footerResource.actions.statusActions) {
    <app-show-status
      [fields]="footerResource.actions.statusActions" [item]="item">
    </app-show-status>
  }
  <!-- {{buttonResource.length}} -->
  @if (buttonResource) {
    <div class="_card-button-container _card-action-btn">
      @for (button of buttonResource; track button) {
        @if (button.valid) {
          <div class="{{button.class_name}}" [ngStyle]="wrapperStyle">
            @if (checkConditionactionname(button) == true) {
              <span>
                <button class="{{button.button_class}}" (click)="buttonAction(button,item)">{{button.text |
                  translate | async}}
                  @if (button.icon_name) {
                    <img class="{{button.icon_class}}"
                      src="assets/images/{{button.icon_name}}">
                    }
                  </button>
                </span>
              }
            </div>
          }
        }
      </div>
    }

  </div>
</div>

<!-- <div class="card card-view" *ngIf="item.serviceType_code !== 'ambulance' && userType !== 'patient'" [ngClass]="checkCondition(item)? 'border-card': 'no-border-card'">
<div class="card-top-section">
  <div class="col-12 float-left p-top-section pl-2 pr-2 pt-2">
    <div *ngIf="!imageURL" class="p-image">
      <img src="./assets/images/user-profile-image.png">
    </div>
    <div *ngIf="imageURL" class="p-image">
      <img [src]="imageURL | safeHtml">
    </div>
    <div class="p-details">
      <p class="p-name">{{item.patient_name}}</p>
    </div>
  </div>
</div>
<div class="card-middle-section">
  <div class="col-12">
    <div class="row">
      <div class="col-sm-6 pl-2">
        <label for="orderId">Order Id</label>
        <p>{{item.orderId}}</p>
      </div>
      <div class="col-sm-6 pl-2">
        <label for="apptTime">Appointment Time</label>
        <p>{{item.slotStartTime | date: 'short'}}</p>
      </div>
      <div class="col-sm-6 pl-2" *ngIf="item.payment_detail">
        <label for="apptPaymentMode">Payment Mode</label>
        <p>{{item.payment_detail[0].payment_mode}}</p>
      </div>
      <div class="col-sm-6 pl-2">
        <label for="apptUHID">MRN/UHID</label>
        <p>{{item.uhId}}</p>
      </div>
      <div class="col-sm-6 pl-2">
        <label for="apptFacility">Clinic/ Hospital</label>
        <p>{{item.facility_name}}</p>
      </div>
      <div class="col-sm-6 pl-2">
        <label for="apptType">Appointment Type</label>
        <p>{{item.serviceItemCode}}</p>
      </div>
      <div class="col-sm-6 pl-2">
        <label for="apptBillNo">Bill No</label>
        <p>{{item.bill_no}}</p>
      </div>
      <div class="col-sm-6 pl-2">
        <label for="apptFeeDue">Fee Due</label>
        <p>{{item.net_amount}}</p>
      </div>
    </div>
  </div>
</div>
<app-show-status *ngIf="footerResource.actions.statusActions" [fields]="footerResource.actions.statusActions" [item]="item">
</app-show-status>
</div> -->
<!-- <div *ngIf="item.serviceType_code=='ambulance'" class="card card-view ambulance-card" (onCreate)="getData(item)">
<div class="header p-2">
  <div class="d-flex pt-1">
    <div class="flex-grow-1">
      <span *ngIf="ambulanceData && ambulanceData.ambulance_name">{{ambulanceData.ambulance_name}}</span><br>
    </div>
    <div *ngIf="ambulanceData" class="bg-dark text-white px-2 mr-4 rounded">ETA {{ambulanceData.duration}}</div>
  </div>
  <span *ngIf="ambulanceStatus && ambulanceStatus.color" [style.color]="ambulanceStatus.color">
    <span class="dot" [style.background-color]="ambulanceStatus.color"></span>{{ambulanceStatus.text}}
  </span>
</div>
<div class="d-flex ambulance-card-body justify-content-center align-items-center">
  <div *ngIf="viewMap">
            <i class="fa fa-ambulance fa-5x" aria-hidden="true" *ngIf="ambulanceData.stage=='approved'
        || ambulanceData.stage=='ridefinished'; else showLocation"></i>
    <ng-template #showLocation>
      <span class="text-danger" *ngIf="!ambulanceData.polyline">* Paramedic not Logged In</span>
      <app-polyline *ngIf="ambulanceData.polyline" [latitude]="ambulanceData.pickup_latitude" [longitude]="ambulanceData.pickup_longitude" [gmap-height]="'24vh'" [gmap-width]="'26vw'" [name]="ambulanceData.id" [polyLineData]="ambulanceData.polyline"></app-polyline>
    </ng-template>
  </div>
  <div class="card-middle-section" *ngIf="!viewMap">
    <div class="col-12">
      <div class="row">
        <div class="col-sm-6 pl-2">
          <label for="orderId">Order Id</label>
          <p>{{item.orderId}}</p>
        </div>
        <div class="col-sm-6 pl-2">
          <label for="apptTime">Appointment Time</label>
          <p>{{item.serviceDate | date: 'short'}}</p>
        </div>
        <div class="col-sm-6 pl-2" *ngIf="item.payment_detail">
          <label for="apptPaymentMode">Payment Mode</label>
          <p>{{item.payment_detail[0].payment_mode}}</p>
        </div>
        <div class="col-sm-6 pl-2">
          <label for="apptUHID">MRN/UHID</label>
          <p>{{item.uhId}}</p>
        </div>
        <div class="col-sm-6 pl-2">
          <label for="apptFacility">Clinic/ Hospital</label>
          <p>{{item.facility_name}}</p>
        </div>
        <div class="col-sm-6 pl-2">
          <label for="apptType">Appointment Type</label>
          <p>{{item.serviceItemName}}</p>
        </div>
        <div class="col-sm-6 pl-2">
          <label for="apptBillNo">Bill No</label>
          <p>{{item.bill_no}}</p>
        </div>
        <div class="col-sm-6 pl-2">
          <label for="apptFeeDue">Pickup Address</label>
          <p *ngIf="ambulanceData && ambulanceData.pickup_address">{{ambulanceData.pickup_address}}</p>
        </div>
        <div class="col-sm-6 pl-2">
          <label for="apptFeeDue">Destination Address</label>
          <p *ngIf="ambulanceData && ambulanceData.destination_address">
          {{ambulanceData.destination_address}}</p>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="footer d-flex">
  <div class="flex-fill text-center">
    <app-show-status *ngIf="footerResource.actions.statusActions" [fields]="footerResource.actions.statusActions" [item]="item">
    </app-show-status>
  </div>
</div>
<div class="tack-ambulance-wrapper">
  <button class="plain-btn" (click)="trackAmbulance()">Track ambulance<img class="track-btn-icon" src="assets/images/icon-track.svg"></button>
</div>
</div> -->